import { Label, RadioGroupItem, RadioGroup, Input } from "ui";

export interface SingleChoiceBaseProps {
  options: { label: string; value: string }[];
  onChange(value: string): void;
  value: string;
  hasOtherOption: boolean;
  otherOptionValue: string;
  onOtherOptionValueChange(value: string): void;
  disabled?: boolean;
}

export type SingleChoiceProps = SingleChoiceBaseProps;

export function SingleChoice(props: SingleChoiceProps) {
  return (
    <>
      <RadioGroup
        onValueChange={(value) => {
          props.onChange(value);
        }}
        value={
          props.hasOtherOption && props.value === "OTHER"
            ? "OTHER"
            : props.value
        }
        disabled={props.disabled}
        className="flex flex-col gap-2"
      >
        {props.options.map((option) => (
          <div key={option.value} className="flex items-center space-x-2">
            <RadioGroupItem value={option.value} id={option.value} />
            <Label htmlFor={option.value}>{option.label}</Label>
          </div>
        ))}
        {props.hasOtherOption && (
          <div className="flex items-center space-x-2">
            <RadioGroupItem
              value="OTHER"
              id="OTHER"
              checked={!!props.otherOptionValue}
            />
            <Label
              htmlFor="OTHER"
              className="flex flex-1 items-center space-x-2"
            >
              <span>Other:</span>
              <Input
                value={props.otherOptionValue}
                onChange={(e) => {
                  props.onOtherOptionValueChange(e.target.value);
                }}
                disabled={props.disabled}
              />
            </Label>
          </div>
        )}
      </RadioGroup>
    </>
  );
}
